var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-10", attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _c("span", [_vm._v("New Purchase Requisition")]),
                  _c("v-spacer"),
                  _c("v-icon", [_vm._v("mdi-account")]),
                  _c("v-icon", [_vm._v("mdi-plus")])
                ],
                1
              ),
              _vm._l(_vm.purchReqPostErrors, function(item, index) {
                return _c(
                  "v-alert",
                  {
                    key: index,
                    staticClass: "mt-2",
                    attrs: { type: "error", dismissible: "" }
                  },
                  [
                    _c("span", { staticClass: "text-uppercase" }, [
                      _vm._v(_vm._s(item.first()))
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: { lg: "3", "offset-lg": "9", cols: "12" }
            },
            [
              _c("v-text-field", {
                attrs: { label: "PR ID", outlined: "", dense: "" },
                model: {
                  value: _vm.prId,
                  callback: function($$v) {
                    _vm.prId = $$v
                  },
                  expression: "prId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "PR Status",
                  items: _vm.purchReqStatusList,
                  filter: _vm.autocompleteFilter(["id", "description"]),
                  "item-value": "id",
                  outlined: "",
                  dense: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.description))]
                        )
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.description))]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.statusID,
                  callback: function($$v) {
                    _vm.statusID = $$v
                  },
                  expression: "statusID"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Date Submitted",
                  dense: "",
                  outlined: "",
                  type: "date"
                },
                model: {
                  value: _vm.submittedDate,
                  callback: function($$v) {
                    _vm.submittedDate = $$v
                  },
                  expression: "submittedDate"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Date Expected",
                  dense: "",
                  outlined: "",
                  type: "date"
                },
                model: {
                  value: _vm.expectedDate,
                  callback: function($$v) {
                    _vm.expectedDate = $$v
                  },
                  expression: "expectedDate"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Amount",
                  type: "number",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "6", cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Notes",
                  dense: "",
                  "no-resize": "",
                  outlined: "",
                  rows: "6"
                },
                model: {
                  value: _vm.notes,
                  callback: function($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "6", cols: "12" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-0 ma-0", attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        staticClass: "ma-0",
                        attrs: {
                          label: "Date Approved",
                          dense: "",
                          type: "date",
                          outlined: ""
                        },
                        model: {
                          value: _vm.approvedDate,
                          callback: function($$v) {
                            _vm.approvedDate = $$v
                          },
                          expression: "approvedDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0", attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Approved By",
                          outlined: "",
                          disabled: "",
                          dense: ""
                        },
                        model: {
                          value: _vm.approvedBy,
                          callback: function($$v) {
                            _vm.approvedBy = $$v
                          },
                          expression: "approvedBy"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Submitted By",
                          outlined: "",
                          dense: ""
                        },
                        model: {
                          value: _vm.submittedBy,
                          callback: function($$v) {
                            _vm.submittedBy = $$v
                          },
                          expression: "submittedBy"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-data-table", {
                attrs: {
                  items: _vm.prItemsNative,
                  headers: _vm.headers,
                  "single-expand": "",
                  "show-expand": "",
                  "hide-default-footer": "",
                  "disable-pagination": "",
                  dense: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "top",
                    fn: function() {
                      return [
                        _c("tr", [
                          _c("th", { attrs: { align: "center" } }, [
                            _vm._v("PR Items")
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "item",
                    fn: function({ item, isExpanded, expand }) {
                      return [
                        _c("tr", [
                          _c("td", { staticClass: "border-right" }, [
                            _vm._v(_vm._s(item.stockId))
                          ]),
                          _c("td", { staticClass: "border-right" }, [
                            _vm._v(_vm._s(item.description))
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "border-right",
                              attrs: { align: "right", width: "100px" }
                            },
                            [_vm._v(_vm._s(item.quantity))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "border-right",
                              attrs: { align: "right" }
                            },
                            [_vm._v(_vm._s(item.cost.toString().formatMoney()))]
                          ),
                          _c(
                            "td",
                            { attrs: { align: "center", width: "10px" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    color: isExpanded ? "yellow" : "green"
                                  },
                                  on: {
                                    click: function($event) {
                                      return expand(!isExpanded)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-pencil")])],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "body.append",
                    fn: function() {
                      return [_c("tr", [_c("td", { attrs: { colspan: "4" } })])]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    loading: _vm.purchReqPosting
                  },
                  on: { click: _vm.storePurchaseRequisition }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "red", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "customer-forecasts.table"
                      })
                    }
                  }
                },
                [_c("span", [_vm._v("Cancel")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }